<script setup lang="ts">
import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { size: "md" });
</script>

<template>
  <SVGWrapper :size="props.size" :background="props.background" viewBox="0 0 24 24">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.18607 15.797C5.99711 16.1691 5.52741 16.3246 5.13797 16.144C4.74853 15.9635 4.58586 15.5146 4.77481 15.1425L8.69891 7.4155C8.83328 7.15108 9.11701 6.98609 9.42452 6.99347C9.73203 7.00097 10.0066 7.1796 10.1267 7.45028L12.5357 12.8819C12.7046 13.2628 12.5181 13.703 12.1197 13.8645C11.7211 14.0258 11.2604 13.8478 11.0914 13.4669L9.35626 9.55451L6.18607 15.797Z"
      fill="#7A7A7A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.1175 12.4248L14.6288 9.46597L14.0104 10.6835C13.8215 11.0557 13.3519 11.2111 12.9625 11.0306C12.573 10.85 12.4103 10.4012 12.5992 10.029L13.9265 7.41548C14.0579 7.15674 14.3326 6.99277 14.6335 6.99323C14.9345 6.99379 15.2086 7.15879 15.3389 7.41799L19.2264 15.145C19.4141 15.5178 19.2496 15.9659 18.8594 16.1451C18.4693 16.3245 18.0003 16.1673 17.8127 15.7945L16.8716 13.9239H14.5844C14.1515 13.9239 13.8001 13.588 13.8001 13.1744C13.8001 12.7607 14.1515 12.4248 14.5844 12.4248H16.1175Z"
      fill="#7A7A7A"
    />
    <path
      d="M4.49212 4.00818C3.11576 4.00818 2 5.10978 2 6.46868V16.8247C2 18.1837 3.11576 19.2852 4.49212 19.2852H10.8854L16.8886 22.2557C17.2135 22.4013 17.5965 22.2591 17.7439 21.9383C17.8913 21.6175 17.7473 21.2394 17.4223 21.0938L11.1647 18.0094H4.49212C3.82943 18.0094 3.29221 17.479 3.29221 16.8247V6.46868C3.29221 5.8144 3.82943 5.284 4.49212 5.284H19.5078C20.1705 5.284 20.7078 5.8144 20.7078 6.46868V16.8247C20.7078 17.479 20.1705 18.0094 19.5078 18.0094H17.2135C16.8567 18.0094 16.5674 18.295 16.5674 18.6473C16.5674 18.9996 16.8567 19.2852 17.2135 19.2852H19.5078C20.8841 19.2852 22 18.1836 22 16.8247V6.46868C22 5.10978 20.8841 4.00818 19.5078 4.00818H4.49212Z"
      fill="#212121"
      fill-opacity="0.6"
    />

    <defs>
      <linearGradient
        id="paint0_linear_8698_8408"
        x1="18.9613"
        y1="23.2439"
        x2="3.17022"
        y2="5.57278"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.126298"
          stop-color="#background: #21212199;
"
        />
        <stop offset="0.876666" stop-color="#21212126" />
      </linearGradient>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
